import classes from './ProjectCardWrapper.module.scss'

import ProjectCard from '../project-card/ProjectCard'

const ProjectCardWrapper = ({ projectsArr }) => {
  return (
    <div className={classes.projects_card_wrapper}>
      {projectsArr.map((project) => {
        return <ProjectCard key={project._id} {...project} />
      })}
    </div>
  )
}

export default ProjectCardWrapper
